export const blockIconsHomeSensorOccupied = (
	<span className='material-symbols-outlined'>sensor_occupied</span>
);
